import React from 'react';

function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold text-primary-700 mb-6 text-center">Terms of Service</h1>
        <p className="text-gray-700 mb-4">
          Welcome to SwiftBidPro! These Terms of Service ("Terms") govern your use of the SwiftBidPro website and services (the "Service"). By accessing or using the Service, you agree to be bound by these Terms.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">1. Acceptance of Terms</h2>
        <p className="text-gray-700 mb-4">
          By creating an account, accessing, or using the Service, you signify that you have read, understood, and agree to be bound by these Terms, whether or not you are a registered user of our Service.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">2. Changes to Terms</h2>
        <p className="text-gray-700 mb-4">
          We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page. Your continued use of the Service after any such changes constitutes your acceptance of the new Terms.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">3. Account Registration and Security</h2>
        <p className="text-gray-700 mb-4">
          You must provide accurate and complete information when registering for an account. You are solely responsible for the activity that occurs on your account and for keeping your password secure.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">4. Use of Service</h2>
        <p className="text-gray-700 mb-4">
          You agree not to engage in any of the following prohibited activities: (a) copying, distributing, or disclosing any part of the Service in any medium; (b) using any automated system to access the Service; (c) transmitting spam, chain letters, or other unsolicited email; (d) attempting to interfere with, compromise the system integrity or security or decipher any transmissions to or from the servers running the Service.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">5. Intellectual Property</h2>
        <p className="text-gray-700 mb-4">
          All content on the Service, including text, graphics, logos, and software, is the property of SwiftBidPro or its licensors and is protected by intellectual property laws.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">6. Limitation of Liability</h2>
        <p className="text-gray-700 mb-4">
          To the maximum extent permitted by applicable law, SwiftBidPro shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (a) your access to or use of or inability to access or use the Service; (b) any conduct or content of any third party on the Service.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">7. Governing Law</h2>
        <p className="text-gray-700 mb-4">
          These Terms shall be governed by the laws of the State of [Your State], without respect to its conflict of laws principles.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">8. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have any questions about these Terms, please contact us at Nicholasnagle9@gmail.com.
        </p>

        <p className="text-gray-500 text-sm text-center mt-8">
          Last updated: June 30, 2025
        </p>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
